const sleep_stages_chart_options = ({ data }) => ({
  title: {
    text: "",
    align: "left",
  },
  subtitle: {
    text: "",
    align: "left",
  },
  chart: {
    zoomType: "x",
    //   type: "line",
    panKey: "alt",
    panning: true,
  },
  xAxis: {
    type: "datetime",
    // gridLineColor: '#D2D8E5',
    lineColor: "#D2D8E5",
    scrollbar: {
      enabled: false,
    },
    labels: {
      style: {
        fontFamily: "Nunito",
        color: "#8F8F8F",
        fontSize: "10px",
      },
    },
  },
  yAxis: {
    title: {
      text: "",
    },
    gridLineColor: "#D2D8E5",
    lineColor: "#D2D8E5",
    categories: ["Deep Sleep", "Light Sleep", "REM", "Awake"],
    labels: {
      align: "right",
    },
    tickmarkPlacement: "on",
  },
  series: [
    {
      name: "Sleep Stages",
      step: "right",
      showInLegend: false,
      data,
      enableMouseTracking: false,
      // gapSize: 2
    },
  ],
  // labels: {
  //     overflow: "scroll"
  // },
  navigator: {
    enabled: false,
  },
  scrollbar: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  // plotOptions: {
  //     series: {
  //         // name: "Sleep Stages",
  //         pointPadding: 0,
  //         groupPadding: 0,
  //         gapSize: 0
  //     },
  //     area: {
  //         step: "center",
  //         stacking: "normal"
  //     },
  //     line: {
  //         marker: {
  //             enabled: false
  //         }
  //     }
  // },
  // exporting: {
  //     enabled: true
  // }
});

export default sleep_stages_chart_options;
